import { useEffect, useState } from "react";
import { _CreditProcessMovement, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import usePaginator from "../../../../../theme/Component/usePaginator";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import { DropDown } from "../../../../../theme/Component/DropDown";
import useModal, { MODAL_SM } from "../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../theme/Component/Modal";
import { ExportXLSL } from "../../../../../theme/Component/ExportXLSX";

interface Props {
    idCreditProcessMovement: number;

}
export const ProcessPaymentView = ({ idCreditProcessMovement }: Props) => {

    const _credit = useDataBean(_CreditProcessMovement);
    const { lista, setLista, bean, setBean, instance } = _credit;
    const [listaAll, setListaAll] = useState<any>([]);
    const modalDownload = useModal("Reporte", MODAL_SM);


    const paginador = usePaginator();

    useEffect(() => {

        if (idCreditProcessMovement > 0) {
            instance.getCreditProcessItemWhitPaymentRender(paginador.page, 15, { IDCreditProcessMovement: idCreditProcessMovement }).then(
                (resp: any) => {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    setLista(resp.List);
                }
            )
        }

    }, [idCreditProcessMovement,paginador.page])


    const head = [
        { title: 'ID', property: 'IDCreditProcessItem', visible: false, mask: MASK_NUMBER },
        { title: 'Fecha Cuota', property: 'CuotaDate', visible: true, mask: MASK_DATE },
        { title: 'Crédito', property: 'CreditNumber', visible: true },
        { title: 'Linea', property: 'LoanName', visible: true },
        { title: 'Identificación', property: 'Nit', visible: true, mask: MASK_NUMBER },
        { title: 'Tercero', property: 'EntityName', visible: true },
        { title: 'Valor Cuota', property: 'VrCuota', visible: true, mask: MASK_MONEY },
        { title: 'Capital Corriente', property: 'CapitalCorriente', visible: true, mask: MASK_MONEY },
        { title: 'Interes Corriente', property: 'InteresCorriente', visible: true, mask: MASK_MONEY },
        // { title: 'Mayor Valor', property: 'HighestPaidAmount', visible: true, mask: MASK_MONEY },
        { title: 'Capital Mora', property: 'CapitalMora', visible: true, mask: MASK_MONEY },
        // { title: 'Interes Mora Acumulado', property: 'SaldoMoraInteres', visible: true, mask: MASK_MONEY },
        { title: 'Interes Mora ', property: 'InteresMora', visible: true, mask: MASK_MONEY },
        { title: 'Saldo Capital', property: 'SaldoCapital', visible: true, mask: MASK_MONEY },
        { title: 'Pago Capital', property: 'PagoCapitalCuota', visible: true, mask: MASK_MONEY },
        { title: 'Pago Interes', property: 'PagoInteresCorrienteCuota', visible: true, mask: MASK_MONEY },
        { title: 'Saldo', property: 'SaldoCapitalCuota', visible: true, mask: MASK_MONEY },

    ];

    const actionsDropDown = [

        { id: 2, name: 'Descargar Detallado', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">

                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {

                        if (e.id == 2) {
                            instance.getCreditProcessItemWhitPaymentRender(1, (paginador.pages * 15) + 20, { IDCreditProcessMovement: idCreditProcessMovement }).then(
                                (resp: any) => {
                                    paginador.setPages(resp.NumberOfPages);
                                    paginador.setRecords(resp.NumberOfPages * 15);
                                    setListaAll(resp.List);
                                    modalDownload.open();
                                }
                            )
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }


    return (
        <div className="row">
            <div className="col">
                <BasicTable
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    // iconButtons={iconButtonsItem}
                    headButtons={buttons()}
                    records={paginador}
                // listButtons={listaBotones()}
                ></BasicTable>
                <Modal modal={modalDownload.modal} updateModal={modalDownload.setModal}>
                    <div className="row">
                        <div className="col-md-12">
                            {listaAll.length > 0 &&
                                <ExportXLSL customName={'pago_cartera'} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaAll} onExport={(name: string) => {
                                    _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                }} />
                            }
                        </div>
                    </div>

                </Modal>
                {/* <PrintJson json={lista} /> */}
            </div>
        </div>
    )
}